import { makeRequest } from 'utils/requestLogger';

export default (id, payload) =>
  makeRequest(
    'put',
    `/api/participations/${id}/select-saved-feedback`,
    payload
  );



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/selectSavedFeedbackLD.js